import { errorCatcher } from './middleware/errorCatcher';
import errorHandler from './utils/errorHandler';
import rootReducer from './reducers';
import {
  AnyAction,
  configureStore,
  DevToolsEnhancerOptions,
  ThunkAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';
import client from '../utils/apollo/client';

// exclude two spam actions in devtools
const reduxDevtoolOptions: DevToolsEnhancerOptions = {
  actionsDenylist: ['auth/updateCapricaGitSha', 'NOTIFICATION_UPDATE'],
};

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production' ? reduxDevtoolOptions : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // https://redux-toolkit.js.org/api/getDefaultMiddleware#included-default-middleware
      // currently Caprica stores JS Date object in the store which is not serializable
      // at some point we should enable it and clean up the store
      serializableCheck: false,
      thunk: {
        extraArgument: {
          apolloClient: client,
        },
      },
    }).concat(errorCatcher(errorHandler)),
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export type ExtraArgs = { apolloClient: typeof client };
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  ExtraArgs,
  AnyAction
>;

export type AppThunkDispatch = ThunkDispatch<RootState, ExtraArgs, AnyAction>;

export default store;
